angular.module('aprima-core-ui').directive('apMediaPicker', ['_', 'MediaService', function (_, MediaService) {
    'use strict';

    return {
        restrict: 'E',
        templateUrl: '/core-ui/views/directives/apMediaPicker.html',
        scope: {
            image: '=ngModel',
            onPicked: '&',
            pickerDescription: '@'
        },
        link: function (scope) {
            scope.pickImage = function () {
                MediaService.getMedia(scope, scope.pickerDescription, function (media, fileName, extension) {
                    scope.image = media;
                    scope.onPicked(media, fileName, extension);
                });
            };
        }
    };
}]);
